import { Radio, styled } from '@mui/material'

export const BlackRadio = styled(Radio)({
  '& .MuiSvgIcon-root': {
    color: 'black',
  },

  '&.Mui-checked .MuiSvgIcon-root': {
    color: 'black',
  },

  '&.Mui-disabled .MuiSvgIcon-root': {
    color: 'black',
    opacity: 0.5,
  },
})
